import { useRef } from 'react';

export function useRandom(from: number, to: number) {
  return useRef(Math.floor(Math.random() * (to - from)) + to);
}
